import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  page: {
    'method': 'GET',
    'url': '/resumes'
  },
  importResumes: { // 关闭邀请
    'method': 'POST',
    'url': '/resumes/import_resumes'
  }
}

export default Vue.resource('/resumes{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/resume.js